__webpack_require__.p = "/select2/onboarding/";